import { computed, defineComponent, onMounted, ref } from "vue";
import {
  LockOutlined,
  UnlockOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
} from "@ant-design/icons-vue";
import { PwdTypeEnum } from "./password-input.interface";
import { bindEmitter } from "@/utils/emitter";

export default defineComponent({
  isGlobal: true,
  name: "PasswordInput",
  components: {
    LockOutlined,
    UnlockOutlined,
    EyeOutlined,
    EyeInvisibleOutlined,
  },
  props: {
    value: String,
    valueModifiers: {
      default: () => ({}),
    },
    placeholder: { type: String, default: "请输入密码" },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const passwordType = ref(PwdTypeEnum.PASSWORD);
    const togglePasswordType = () => {
      if (passwordType.value === PwdTypeEnum.PASSWORD) {
        passwordType.value = PwdTypeEnum.TEXT;
      } else {
        passwordType.value = PwdTypeEnum.PASSWORD;
      }
    };
    const onChange = ($event) => {
      emit("update:value", $event.target.value);
    };
    const isLock = computed(() => passwordType.value === PwdTypeEnum.PASSWORD);
    onMounted(() => {
      bindEmitter("show-password-text", () => {
        passwordType.value = PwdTypeEnum.TEXT;
      });
    });
    return {
      passwordType,
      isLock,
      togglePasswordType,
      onChange,
    };
  },
});
